export default "__VITE_ASSET__5Pa8Ja1s__"